module.exports = __webpack_public_path__ + "img/fontello.11c43979.svg";